import { memo, type ReactNode } from 'react';

import { PrivateFiltersReduxObserver } from '~/components/Filters/PrivateFiltersReduxObserver';
import { SearchPageContent } from '~/components/v2/components/search/SearchPageContent';
import { SearchPageHeader } from '~/components/v2/components/search/SearchPageHeader';
import { SmartSearchBottomBar } from '~/components/v2/components/search/SmartSearchBottomBar';
import { PrivatePageSeoTitle } from '~/components/v2/components/shared/seo/PrivatePageSeoTitle';
import { GENERAL_PAGE_ID, useBoardlessConfigView } from '~/hooks/useBoardlessConfigView/useBoardlessConfigView';

export type SearchPageProps = {
  children: ReactNode;
};

export const SearchPage = memo(({ children }: SearchPageProps) => {
  const { BoardlessConfigObserver } = useBoardlessConfigView({ pageId: GENERAL_PAGE_ID });

  return (
    <>
      <PrivatePageSeoTitle title="Search" />
      {BoardlessConfigObserver}
      <PrivateFiltersReduxObserver />
      <SearchPageHeader />
      <SearchPageContent />
      <SmartSearchBottomBar />
      {children}
    </>
  );
});

SearchPage.displayName = 'SearchPage';
